import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { actions as setPreferredPharmacyActions } from '../../../../redux/healthboard/patientPortal/set-preferred-pharmacy-req';
import { actions as medicationRefillsRequestActions } from '../../../../redux/healthboard/patientPortal/medication-refill-req';
import { actions as refillsAvailableMedicationsActions } from '../../../../redux/healthboard/patientPortal/refills-available-medications-req';
import {
  loggedUserSelector,
  targetUserSelector,
} from '../../../../redux/context/selectors';
import {
  selectMedicationsRefillsHistoryList,
  selectRefillsAvailableMedicationsList,
  selectMedicationRefillsRequestPending,
  selectMedicationsRefillsHistoryPending,
  selectRefillsAvailableMedicationsPending,
  selectMedicationRefillsUnavailablePharmacyError,
} from '../../../../redux/healthboard/patientPortal/selectors';
import { selectPreferredPharmacy } from '../../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  targetUser: targetUserSelector(state),
  loggedUser: loggedUserSelector(state),
  currentPharmacyId: selectPreferredPharmacy(state),
  pendingHistory: selectMedicationsRefillsHistoryPending(state),
  refillsHistoryList: selectMedicationsRefillsHistoryList(state),
  refillRequestPending: selectMedicationRefillsRequestPending(state),
  refillsAvailableMedications: selectRefillsAvailableMedicationsList(state),
  refillRequestError: selectMedicationRefillsUnavailablePharmacyError(state),
  refillsAvailableMedicationsPending: selectRefillsAvailableMedicationsPending(
    state,
  ),
});

const mapDispatchToProps = {
  clear: refillsAvailableMedicationsActions.clear,
  setPreferredPharmacy: setPreferredPharmacyActions.send,
  clearRefillRequest: medicationRefillsRequestActions.clear,
  initMedicationRefill: medicationRefillsRequestActions.init,
  getAvailableMedications: refillsAvailableMedicationsActions.send,
};

export const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ targetUser, loggedUser, currentPharmacyId }) => {
    const safeUser = targetUser.id ? targetUser : loggedUser;
    return {
      safeUser,
      definePharmacy:
        get(safeUser, 'primaryPatientProfile.pharmacy') || currentPharmacyId,
    };
  }),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/Refills/enhance.js